var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C1.03548e-08 8.26311 0.0872744 8.02622 0.274293 7.8392L7.84232 0.271176C8.20389 -0.0903933 8.80235 -0.0903915 9.16392 0.271178C9.52549 0.632748 9.52549 1.23121 9.16392 1.59278L2.25669 8.5L9.16392 15.4072C9.52549 15.7688 9.52549 16.3673 9.16392 16.7288C8.80235 17.0904 8.20389 17.0904 7.84232 16.7288L0.274293 9.1608C0.0872744 8.97378 -1.03548e-08 8.73689 0 8.5Z",
    fill: "#8F98A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fadd71c82d0578192b0c2a38124f4532.svg";
export { ForwardRef as ReactComponent };